'use client';

import Link from '@eliadmin/core/src/components/link';

import type { TDynamicData } from '../../types/dynamic-data';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import { GrDocumentText } from 'react-icons/gr';

export function FileDownload({ item }: { item: TDynamicData }) {
  return (
    <Link
      prefetch={false}
      href={item.fields[1].file?.url ?? '/'}
      target="_blank"
      rel="noopener noreferrer"
      className={cn(
        'ea-file-download',
        'flex w-full items-center justify-between gap-5 bg-white p-5 transition-all hover:bg-neutral-50',
      )}
    >
      <p className="text-sm font-bold text-primary sm:text-base">{item.name}</p>
      <div className="flex min-h-11 min-w-11 items-center justify-center rounded-full bg-primary/5 sm:min-h-12 sm:min-w-12 lg:min-h-[50px] lg:min-w-[50px]">
        <GrDocumentText className="h-[18px] w-[18px] text-secondary sm:h-5 sm:w-5" />
      </div>
    </Link>
  );
}
